(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---------------- Selling Fast ---------------- */
  function initSellingFast(root) {
    if (root.dataset.r) return; root.dataset.r = '1';
    var minutes = parseInt(root.dataset.minutes, 10) || 53;
    var timerEl = root.querySelector('[data-sf-timer]');
    var key = 'strider_sf_end_' + minutes, end;
    try { end = parseInt(localStorage.getItem(key), 10); } catch (e) {}
    var now = Date.now();
    if (!end || end < now) { end = now + minutes * 60000; try { localStorage.setItem(key, end); } catch (e) {} }
    function tick() {
      var d = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (timerEl) timerEl.textContent = pad(Math.floor(d / 60)) + ':' + pad(d % 60);
      if (d <= 0) { end = Date.now() + minutes * 60000; try { localStorage.setItem(key, end); } catch (e) {} }
    }
    tick(); setInterval(tick, 1000);
    var pill = root.querySelector('.sf2-pill'), t = root.querySelector('[data-sf-toggle]'), dt = root.querySelector('[data-sf-detail]');
    if (pill && dt) {
      pill.style.cursor = 'pointer';
      pill.addEventListener('click', function () {
        var o = dt.hasAttribute('hidden');
        if (o) { dt.removeAttribute('hidden'); if (t) t.setAttribute('aria-expanded', 'true'); }
        else { dt.setAttribute('hidden', ''); if (t) t.setAttribute('aria-expanded', 'false'); }
      });
    }
  }

  /* ---------------- Size Quiz ---------------- */
  function initQuiz(root) {
    if (root.dataset.r) return; root.dataset.r = '1';
    var sizes = (root.dataset.sizes || '').split('||').map(function (x) { return x.trim(); }).filter(Boolean);
    var menOffset = parseFloat(root.dataset.menOffset || '1.5');
    var buckets = sizes.map(function (l) {
      var us = (l.match(/US\/CA\s*([0-9.]+)/) || [])[1];
      var eu = (l.match(/EU\s*([0-9.]+)/) || [])[1];
      return { label: l, us: parseFloat(us), eu: eu || '' };
    }).filter(function (b) { return !isNaN(b.us); });

    var modal = root.querySelector('[data-sq-modal]'), body = root.querySelector('[data-sq-body]');
    var prog = root.querySelector('[data-sq-progress]'), back = root.querySelector('[data-sq-back]');
    var TOTAL = 7;

    var STEPS = [
      { key: 'brand', q: 'Which brand do you usually wear?', hint: 'This helps us match your current fit.', brand: true,
        popular: [{ label: 'Nike', value: 'Nike' }, { label: 'Adidas', value: 'Adidas' }],
        other: [{ em: '🏃', label: 'New Balance', value: 'New Balance' }, { em: '👣', label: 'Skechers', value: 'Skechers' }, { em: '🛹', label: 'Vans', value: 'Vans' }, { em: '⭐', label: 'Converse', value: 'Converse' }, { em: '🐆', label: 'Puma', value: 'Puma' }, { em: '💪', label: 'Reebok', value: 'Reebok' }] },
      { key: 'size', q: 'What size do you take in that brand?', hint: 'Pick your most common size.', sizePicker: true },
      { key: 'fit', q: 'How do those usually fit?', hint: 'Think about a full day of wear.',
        opts: [{ em: '😣', label: 'Too tight', sub: 'My toes feel cramped', value: 'tight' }, { em: '😊', label: 'Perfect', sub: 'Comfortable all day', value: 'perfect' }, { em: '😐', label: 'Too loose', sub: 'My foot slides around', value: 'loose' }] },
      { key: 'width', q: 'How would you describe your feet?', hint: 'Choose the closest match.',
        opts: [{ label: 'Narrow', sub: 'Slim feet, often need narrow sizes', value: 'narrow' }, { label: 'Normal', sub: 'Standard width, most shoes fit', value: 'regular' }, { label: 'Wide', sub: 'Need extra room in the toe box', value: 'wide' }, { label: 'Very wide', sub: 'Often size up for width', value: 'xwide' }] },
      { key: 'toe', q: 'How much toe room do you prefer?', hint: 'More room means more natural movement.',
        opts: [{ em: '🤏', label: 'Snug fit', sub: 'Like athletic shoes', value: 'snug' }, { em: '😊', label: 'Natural fit', sub: 'Comfortable wiggle room', value: 'natural' }, { em: '😣', label: 'Extra space', sub: 'Maximum toe freedom', value: 'roomy' }] },
      { key: 'cond', q: 'Anything we should know about your feet?', hint: 'Select all that apply.', multi: true,
        opts: [{ label: 'Bunions', value: 'bunions' }, { label: 'Flat feet', value: 'flat' }, { label: 'High arches', value: 'arch' }, { label: 'Plantar fasciitis', value: 'pf' }, { label: 'Wide forefoot', value: 'forefoot' }, { label: 'None', value: 'none' }] },
      { key: 'use', q: 'Where will you wear them most?', hint: 'Last one!',
        opts: [{ em: '🚶', label: 'Daily walking', sub: 'Everyday wear around town', value: 'daily' }, { em: '💼', label: 'Work', sub: 'Long hours on your feet', value: 'work' }, { em: '😎', label: 'Casual', sub: 'Errands and outings', value: 'casual' }, { em: '⛰️', label: 'Outdoors', sub: 'Trails and terrain', value: 'outdoor' }, { em: '🏋️', label: 'Exercise', sub: 'Workouts and fitness', value: 'gym' }] }
    ];

    var st = { i: 0, gender: 'women', size: null, ans: {}, cond: [] };
    function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; st = { i: 0, gender: 'women', size: null, ans: {}, cond: [] }; render(); }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }
    function next() { st.i++; render(); }
    function esc(s) { return String(s).replace(/"/g, '&quot;'); }

    function renderProg() {
      prog.innerHTML = '';
      for (var i = 0; i < TOTAL; i++) {
        var d = document.createElement('span'); d.className = 'sq2-pdot' + (i <= st.i ? ' on' : ''); d.textContent = (i + 1); prog.appendChild(d);
        if (i < TOTAL - 1) { var ln = document.createElement('span'); ln.className = 'sq2-pline'; prog.appendChild(ln); }
      }
    }

    function render() {
      renderProg(); back.hidden = st.i === 0;
      if (st.i >= STEPS.length) { result(); return; }
      var s = STEPS[st.i];
      var h = '<p class="sq2-q">' + s.q + '</p><p class="sq2-hint">' + s.hint + '</p>';
      if (s.brand) {
        h += '<p class="sq2-cap">MOST POPULAR</p><div class="sq2-grid">';
        s.popular.forEach(function (o) { h += '<button class="sq2-opt between" data-val="' + esc(o.value) + '"><b>' + o.label + '</b></button>'; });
        h += '</div><p class="sq2-cap muted">OTHER BRANDS</p><div class="sq2-grid g3">';
        s.other.forEach(function (o) { h += '<button class="sq2-opt center" data-val="' + esc(o.value) + '"><span class="em">' + o.em + '</span><b>' + o.label + '</b></button>'; });
        h += '</div>';
      } else if (s.sizePicker) {
        h += '<div class="sq2-toggle"><button data-g="women" class="' + (st.gender === 'women' ? 'on' : '') + '">Women</button><button data-g="men" class="' + (st.gender === 'men' ? 'on' : '') + '">Men</button></div>';
        h += '<div class="sq2-grid g3" style="grid-template-columns:repeat(5,1fr)">';
        ['5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12'].forEach(function (n) { h += '<button class="sq2-sq" data-size="' + n + '">' + n + '</button>'; });
        h += '</div>';
      } else {
        h += '<div class="sq2-list">';
        s.opts.forEach(function (o) {
          var sel = s.multi && st.cond.indexOf(o.value) > -1 ? ' sel' : '';
          h += '<button class="sq2-opt' + sel + '" data-val="' + esc(o.value) + '">' + (o.em ? '<span class="em">' + o.em + '</span>' : '') + '<span class="tx"><b>' + o.label + '</b>' + (o.sub ? '<small>' + o.sub + '</small>' : '') + '</span></button>';
        });
        h += '</div>';
        if (s.multi) h += '<button class="sq2-proceed" data-proceed>Continue</button>';
      }
      body.innerHTML = h; bind(s);
    }

    function bind(s) {
      if (s.sizePicker) {
        body.querySelectorAll('[data-g]').forEach(function (b) { b.onclick = function () { st.gender = b.dataset.g; render(); }; });
        body.querySelectorAll('[data-size]').forEach(function (b) { b.onclick = function () { st.size = parseFloat(b.dataset.size); next(); }; });
        return;
      }
      body.querySelectorAll('[data-val]').forEach(function (b) {
        b.onclick = function () {
          if (s.multi) {
            var v = b.dataset.val;
            if (v === 'none') { st.cond = ['none']; }
            else { st.cond = st.cond.filter(function (x) { return x !== 'none'; }); var i = st.cond.indexOf(v); if (i > -1) st.cond.splice(i, 1); else st.cond.push(v); }
            render();
          } else { st.ans[s.key] = b.dataset.val; next(); }
        };
      });
      var pr = body.querySelector('[data-proceed]'); if (pr) pr.onclick = function () { if (!st.cond.length) st.cond = ['none']; next(); };
    }

    function recommend() {
      var base = st.size || 8; if (st.gender === 'men') base += menOffset;
      var adj = 0;
      if (st.ans.fit === 'tight') adj += 0.5; if (st.ans.fit === 'loose') adj -= 0.5;
      if (st.ans.width === 'wide') adj += 0.5; if (st.ans.width === 'xwide') adj += 1;
      if (st.ans.toe === 'roomy') adj += 0.5;
      if (st.cond.indexOf('bunions') > -1 || st.cond.indexOf('forefoot') > -1) adj += 0.5;
      var target = base + adj, best = buckets[0], bd = 99;
      buckets.forEach(function (b) { var d = Math.abs(b.us - target); if (d < bd) { bd = d; best = b; } });
      var conf = Math.max(85, 96 - (Math.round(bd * 4) + Math.round(Math.abs(adj) * 2)));
      return { b: best, conf: conf };
    }

    function result() {
      renderProg(); back.hidden = true;
      var r = recommend(), b = r.b, d = root.dataset, big = b ? b.label.split('·')[0].trim() : '';
      var h = '' +
        '<div class="sq2-badge"><svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M8.21 13.89 7 23l5-3 5 3-1.21-9.12"/></svg></div>' +
        '<p class="sq2-rh">Your Perfect Fit Found!</p><p class="sq2-rs">Based on your unique foot profile</p>' +
        '<div class="sq2-rcard"><p class="sq2-rlabel">WE RECOMMEND</p><div class="sq2-rsize">' + big + '</div><div class="sq2-reu">' + (b ? b.label : '') + '</div>' +
        '<span class="sq2-pill">&#128200; ' + r.conf + '% match confidence</span></div>' +
        '<div class="sq2-perf"><span class="ck">&#10003;</span><span><b>Perfect fit:</b> optimized for your foot profile</span></div>' +
        '<div class="sq2-stats"><div class="sq2-stat"><b>' + d.stat1n + '</b><span>' + d.stat1l + '</span></div><div class="sq2-stat"><b>' + d.stat2n + '</b><span>' + d.stat2l + '</span></div><div class="sq2-stat"><b>' + d.stat3n + '</b><span>' + d.stat3l + '</span></div></div>' +
        '<button class="sq2-cta" data-pick>Select ' + big + ' &#8594;</button>' +
        '<button class="sq2-retake" data-retake>Retake quiz</button>';
      body.innerHTML = h;
      body.querySelector('[data-retake]').onclick = function () { st = { i: 0, gender: 'women', size: null, ans: {}, cond: [] }; render(); };
      body.querySelector('[data-pick]').onclick = function () { apply(b); close(); };
    }

    function apply(b) {
      if (!b) return;
      try { localStorage.setItem('strider_recommended_size', b.label); } catch (e) {}
      window.dispatchEvent(new CustomEvent('strider:size-recommended', { detail: { label: b.label, us: b.us, eu: b.eu } }));
      document.querySelectorAll('select').forEach(function (sel) {
        for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].text.trim() === b.label) { sel.value = sel.options[i].value; sel.dispatchEvent(new Event('change', { bubbles: true })); break; } }
      });
      var bx = document.querySelector('.product-form, product-info'); if (bx) bx.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    root.querySelector('[data-sq-open]').addEventListener('click', open);
    root.querySelectorAll('[data-sq-close]').forEach(function (b) { b.addEventListener('click', close); });
    back.addEventListener('click', function () { if (st.i > 0) { st.i--; render(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  
  /* ---------------- Custom Size Dropdown ---------------- */
  function initSizeDropdown(wrap) {
    if (wrap.dataset.sd) return;
    var sel = wrap.querySelector('select');
    if (!sel) return;
    wrap.dataset.sd = '1';
    var box = document.createElement('div'); box.className = 'sd-box';
    var trg = document.createElement('button'); trg.type = 'button'; trg.className = 'sd-trigger'; trg.setAttribute('aria-expanded','false');
    var lab = document.createElement('span'); lab.className = 'sd-label';
    var chev = document.createElement('span'); chev.className = 'sd-chev'; chev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
    trg.appendChild(lab); trg.appendChild(chev);
    var panel = document.createElement('div'); panel.className = 'sd-panel'; panel.hidden = true;
    function setLabel() { var o = sel.options[sel.selectedIndex]; lab.textContent = o ? o.textContent.trim() : ''; }
    [].forEach.call(sel.options, function (opt) {
      if (opt.disabled && opt.value === '') return;
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'sd-opt' + (opt.selected ? ' is-sel' : '') + (opt.disabled ? ' is-un' : '');
      b.textContent = opt.textContent.trim();
      b.addEventListener('click', function () {
        sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true }));
        setLabel();
        [].forEach.call(panel.querySelectorAll('.sd-opt'), function (x) { x.classList.remove('is-sel'); });
        b.classList.add('is-sel');
        panel.hidden = true; trg.setAttribute('aria-expanded', 'false');
      });
      panel.appendChild(b);
    });
    setLabel();
    trg.addEventListener('click', function (e) { e.stopPropagation(); var open = panel.hidden; panel.hidden = !open; trg.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) { panel.hidden = true; trg.setAttribute('aria-expanded', 'false'); } });
    sel.addEventListener('change', setLabel);
    box.appendChild(trg); box.appendChild(panel);
    sel.style.display = 'none';
    sel.parentNode.insertBefore(box, sel.nextSibling);
  }

  function boot() {
    document.querySelectorAll('[data-sellingfast]').forEach(initSellingFast);
    document.querySelectorAll('[data-sizequiz]').forEach(initQuiz);
    document.querySelectorAll('.product-form__input--dropdown').forEach(initSizeDropdown);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
